module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    ref: "wrap",
    class: ['vue-slider-wrap', _vm.flowDirection, _vm.disabledClass, {
      'vue-slider-has-label': _vm.piecewiseLabel
    }],
    style: (_vm.wrapStyles),
    on: {
      "click": _vm.wrapClick
    }
  }, [_c('div', {
    ref: "elem",
    staticClass: "vue-slider",
    style: ([_vm.elemStyles, _vm.bgStyle])
  }, [(_vm.isMoblie) ? [(_vm.isRange) ? [_c('div', {
    ref: "dot0",
    class: [_vm.tooltipStatus, 'vue-slider-dot'],
    style: ([_vm.sliderStyles[0], _vm.dotStyles]),
    on: {
      "touchstart": function($event) {
        _vm.moveStart(0)
      }
    }
  }, [_c('span', {
    class: ['vue-slider-tooltip-' + _vm.tooltipDirection[0], 'vue-slider-tooltip'],
    style: (_vm.tooltipStyles[0])
  }, [_vm._v(_vm._s(_vm.formatter ? _vm.formatting(_vm.val[0]) : _vm.val[0]))])]), _vm._v(" "), _c('div', {
    ref: "dot1",
    class: [_vm.tooltipStatus, 'vue-slider-dot'],
    style: ([_vm.sliderStyles[1], _vm.dotStyles]),
    on: {
      "touchstart": function($event) {
        _vm.moveStart(1)
      }
    }
  }, [_c('span', {
    class: ['vue-slider-tooltip-' + _vm.tooltipDirection[1], 'vue-slider-tooltip'],
    style: (_vm.tooltipStyles[1])
  }, [_vm._v(_vm._s(_vm.formatter ? _vm.formatting(_vm.val[1]) : _vm.val[1]))])])] : [_c('div', {
    ref: "dot",
    class: [_vm.tooltipStatus, 'vue-slider-dot'],
    style: ([_vm.sliderStyles, _vm.dotStyles]),
    on: {
      "touchstart": _vm.moveStart
    }
  }, [_c('span', {
    class: ['vue-slider-tooltip-' + _vm.tooltipDirection, 'vue-slider-tooltip'],
    style: (_vm.tooltipStyles)
  }, [_vm._v(_vm._s(_vm.formatter ? _vm.formatting(_vm.val) : _vm.val))])])]] : [(_vm.isRange) ? [_c('div', {
    ref: "dot0",
    class: [_vm.tooltipStatus, 'vue-slider-dot'],
    style: ([_vm.sliderStyles[0], _vm.dotStyles]),
    on: {
      "mousedown": function($event) {
        _vm.moveStart(0)
      }
    }
  }, [_c('span', {
    class: ['vue-slider-tooltip-' + _vm.tooltipDirection[0], 'vue-slider-tooltip'],
    style: (_vm.tooltipStyles[0])
  }, [_vm._v(_vm._s(_vm.formatter ? _vm.formatting(_vm.val[0]) : _vm.val[0]))])]), _vm._v(" "), _c('div', {
    ref: "dot1",
    class: [_vm.tooltipStatus, 'vue-slider-dot'],
    style: ([_vm.sliderStyles[1], _vm.dotStyles]),
    on: {
      "mousedown": function($event) {
        _vm.moveStart(1)
      }
    }
  }, [_c('span', {
    class: ['vue-slider-tooltip-' + _vm.tooltipDirection[1], 'vue-slider-tooltip'],
    style: (_vm.tooltipStyles[1])
  }, [_vm._v(_vm._s(_vm.formatter ? _vm.formatting(_vm.val[1]) : _vm.val[1]))])])] : [_c('div', {
    ref: "dot",
    class: [_vm.tooltipStatus, 'vue-slider-dot'],
    style: ([_vm.sliderStyles, _vm.dotStyles]),
    on: {
      "mousedown": _vm.moveStart
    }
  }, [_c('span', {
    class: ['vue-slider-tooltip-' + _vm.tooltipDirection, 'vue-slider-tooltip'],
    style: (_vm.tooltipStyles)
  }, [_vm._v(_vm._s(_vm.formatter ? _vm.formatting(_vm.val) : _vm.val))])])]], _vm._v(" "), (_vm.piecewise) ? [_c('ul', {
    staticClass: "vue-slider-piecewise"
  }, _vm._l((_vm.piecewiseDotWrap), function(piecewiseObj, index) {
    return _c('li', {
      style: ([_vm.piecewiseDotStyle, piecewiseObj.style])
    }, [_c('span', {
      staticClass: "vue-slider-piecewise-dot",
      style: ([_vm.piecewiseStyle, piecewiseObj.inRange ? _vm.piecewiseActiveStyle : null])
    }), _vm._v(" "), (_vm.piecewiseLabel) ? _c('span', {
      staticClass: "vue-slider-piecewise-label",
      style: ([_vm.labelStyle, piecewiseObj.inRange ? _vm.labelActiveStyle : null])
    }, [_vm._v(_vm._s(piecewiseObj.label))]) : _vm._e()])
  }))] : _vm._e(), _vm._v(" "), _c('div', {
    ref: "process",
    staticClass: "vue-slider-process",
    style: (_vm.processStyle)
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f9461b40"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-slider-component/src/vue2-slider.vue
// module id = 9
// module chunks = 0